export enum EnabledBookingDocumentsByCondition {
  ENABLED_DOCUMENTS_MODULE = 'ENABLED_DOCUMENTS_MODULE',
  ENABLED_DOCUMENTS_ONLY_INTERNATIONAL_TRIP = 'ENABLED_DOCUMENTS_ONLY_INTERNATIONAL_TRIP',
  ENABLED_DOCUMENTS_BY_AIRLINE = 'ENABLED_DOCUMENTS_BY_AIRLINE',
  ENABLED_DOCUMENTS_BY_PROVIDER = 'ENABLED_DOCUMENTS_BY_PROVIDER',
  ENABLED_DOCUMENTS_BY_AIRLINE_AND_PROVIDER = 'ENABLED_DOCUMENTS_BY_AIRLINE_AND_PROVIDER',
}

export enum EnabledBookingDocumentsByAirlineValues {
  TAR = 'YQ',
  VH = 'VH'
}

export enum EnabledBookingDocumentsByProviderValues {
  KIU = 'KIU',
  VivaColombia = 'VivaColombia'
}

export enum IgnoreEnabledBookingDocumentsByCondition {
  IS_INTERNATIONAL_TRIP = 'IS_INTERNATIONAL_TRIP',
  AIRLINE_IS_EQUAL_TO = 'AIRLINE_IS_EQUAL_TO'
}
